/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState} from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import {API_UPLOADS, API_GET_PUBLIC} from "../../api";
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Router]
-------------------------------------------------------------------*/
import { Link } from "react-router-dom";
/*------------------------------------------------------------------
[End React Router]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Module]
-------------------------------------------------------------------*/
import LinesEllipsis from 'react-lines-ellipsis'
import { decode } from "html-entities";
import Slider from "react-slick";
import Fade from 'react-reveal/Fade';

import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
/*------------------------------------------------------------------
[End React Module]
-------------------------------------------------------------------*/

const settings = {
	lazyLoad: true,
	autoplay : true,
	autoplaySpeed : 5000,
	dots: false,
	infinite: true,
	speed: 500,
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: true
};

const Screen = ({error, setting, header_text, header, header_slider_background, header_video, gallery}) => {

	const [data, set_data] = useState(null);

	const [search, set_search] = useState('');

	const _read = () => {

        API_GET_PUBLIC(`client/post_search__________?search=${search}`)
        .then((response) => {
			console.log('search : ', response.data)
            if(response.data.result === 'success'){
				set_data(response.data.data)
				error('')
            }else if(response.data.error){
				error(response.data.error)
				set_data(null)
            }
        })
        .catch((e) => {
            console.log('catch : ', e)
            error(e.message)
			set_data(null)
		})

    }
    
    useEffect(() => {
		
		if(search){
			_read()
		}else{
			set_data('')
		}

    }, [search])

	return (
		<>

			{
				setting && setting.header === 'background' ?
					header && header.length > 0 &&
					<div className="__header" style={{backgroundImage: `url(${API_UPLOADS + header[0].background})`}}>
						<div className="_position_middle _lily_pad_h_d _center_text">
							<Fade top cascade>
								<h1>{header[0].title}</h1>
							</Fade>
							<p style={{maxWidth: 650, color: '#fff', fontSize: 18}}>{header[0].description}</p>
								
							<div className="__header_search">
								<input 
									placeholder={'Cari Disini ?'} 
									onChange={e => set_search(e.target.value)}
									value={search}
								/>
								{data ?
									<div className="__header_search_contant">
										{
											data.map((item, index) => {
												
												return (

													<Link
														key={index} 
														to={{
															pathname: 'post/' + item.slug,
														}} 
													>
														<div className="_row _push_b_s" style={{alignItems: 'center'}}>
															<div className="_push_r_m">
																<ion-icon name="search-outline" style={{marginTop: 6}}></ion-icon>
															</div>
															<div className="_column">
																<LinesEllipsis
																	text={decode(item.title)}
																	maxLine='1'
																	ellipsis='...'
																	trimRight
																	basedOn='letters'
																/>
															</div>
														</div>
													</Link>

												)
												
											})
										}
									</div>
									: null
								}
							</div>
						
						</div>
					</div>
				: setting && setting.header === 'slider' ? 
					header && header.length > 0 &&
					<div className="__slick_container">
						<Slider {...settings}>
							{
								header_slider_background && header_slider_background.map((item, index) => (
									<div key={index}>
										<div className="__header" style={{backgroundImage: `url(${API_UPLOADS + item.background})`}}>
											<div className="_position_middle _lily_pad_h_d _center_text">
												<Fade top cascade>
													<h1>{item.title}</h1>
												</Fade>
												<p style={{maxWidth: 650, color: '#fff', fontSize: 18}}>{item.description}</p>
											</div>
										</div>
									</div>
								))
							}
						</Slider>
						<div className="_container" style={{marginTop: -30}}>
							
							<div className="__header_search" style={{width: '100%'}}>
								<input 
									placeholder={'Cari Disini ?'} 
									onChange={e => set_search(e.target.value)}
									value={search}
								/>
								{data ?
									<div className="__header_search_contant">
										{
											data.map((item, index) => {
												
												return (

													<Link
														key={index} 
														to={{
															pathname: 'post/' + item.slug,
														}} 
													>
														<div className="_row _push_b_s" style={{alignItems: 'center'}}>
															<div className="_push_r_m">
																<ion-icon name="search-outline" style={{marginTop: 6}}></ion-icon>
															</div>
															<div className="_column">
																<LinesEllipsis
																	text={decode(item.title)}
																	maxLine='1'
																	ellipsis='...'
																	trimRight
																	basedOn='letters'
																/>
															</div>
														</div>
													</Link>

												)
												
											})
										}
									</div>
									: null
								}
							</div>
						
						</div>
					</div>

				: setting && setting.header === 'video' ? 
					header && header.length > 0 &&
					<div className="__header_video_container">
						<div className="__video_container">
							<video autoplay='true' loop='true' muted='true'>
								<source src={API_UPLOADS + header_video[0].video} type="video/mp4"/>
								Your browser does not support the video tag.
							</video>
							<div className="_position_middle _lily_pad_h_d _center_text">
								<Fade top cascade>
									<h1>{header[0].title}</h1>
								</Fade>
								<p style={{maxWidth: 650, color: '#fff', fontSize: 18}}>{header[0].description}</p>
							
								<div className="__header_search">
									<input 
										placeholder={'Cari Disini ?'} 
										onChange={e => set_search(e.target.value)}
										value={search}
									/>
									{data ?
										<div className="__header_search_contant">
											{
												data.map((item, index) => {
													
													return (

														<Link
															key={index} 
															to={{
																pathname: 'post/' + item.slug,
															}} 
														>
															<div className="_row _push_b_s" style={{alignItems: 'center'}}>
																<div className="_push_r_m">
																	<ion-icon name="search-outline" style={{marginTop: 6}}></ion-icon>
																</div>
																<div className="_column">
																	<LinesEllipsis
																		text={decode(item.title)}
																		maxLine='1'
																		ellipsis='...'
																		trimRight
																		basedOn='letters'
																	/>
																</div>
															</div>
														</Link>

													)
													
												})
											}
										</div>
										: null
									}
								</div>
							
							</div>
						</div>
					</div>

				: setting && setting.header === 'gallery' ? 
					gallery && gallery.length > 0 &&
					<div className="__header_container">
						<div className="__header_image">
							{
								gallery ? 
									gallery.map((item, index) => (
										<div key={index}>
											<div className="__header_image_item" style={{backgroundImage: `url(${API_UPLOADS + item.media})`}} />
										</div>
									))
								:
									new Array(10).fill(undefined).map((index) => (
										<div key={index}>
											<div className="__header_image_item" />
										</div>
									))
							}
						</div>
						<div className="_position_middle _lily_pad_h_d">
							{
								setting?
									<div className="_center_text">
										<Fade top cascade>
											<h1 className="_push_b_m _center_text _cl_coco_000 _text_overflow">{header[0].title}</h1>
										</Fade>
										<p style={{maxWidth: 650, color: '#fff', fontSize: 18}}>{header[0].description}</p>
									</div>
								: null
							}
							<div className="__header_search">
								<input 
									placeholder={'Cari Disini ?'} 
									onChange={e => set_search(e.target.value)}
									value={search}
								/>
								{data ?
									<div className="__header_search_contant">
										{
											data.map((item, index) => {
												
												return (

													<Link
														key={index} 
														to={{
															pathname: 'post/' + item.slug,
														}} 
													>
														<div className="_row _push_b_s" style={{alignItems: 'center'}}>
															<div className="_push_r_m">
																<ion-icon name="search-outline" style={{marginTop: 6}}></ion-icon>
															</div>
															<div className="_column">
																<LinesEllipsis
																	text={decode(item.title)}
																	maxLine='1'
																	ellipsis='...'
																	trimRight
																	basedOn='letters'
																/>
															</div>
														</div>
													</Link>

												)
												
											})
										}
									</div>
									: null
								}
							</div>
						</div>
					</div>
				
				: null
			}

		</>
	);
}

export default Screen;